import { render } from "./FileComponent.vue?vue&type=template&id=e80cd7fc&scoped=true"
import script from "./FileComponent.vue?vue&type=script&lang=js"
export * from "./FileComponent.vue?vue&type=script&lang=js"

import "./FileComponent.vue?vue&type=style&index=0&id=e80cd7fc&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e80cd7fc"]])

export default __exports__